export const getAdmins = (obj) => ({
  type: "GET_ADMINS",
  obj,
});

export const getAdminsSuccess = (data) => ({
  type: "GET_ADMINS_SUCCESS",
  data,
});

export const getAdminsFail = (error) => ({
  type: "GET_ADMINS_FAIL",
  error,
});
export const getHighways = (obj) => ({
  type: "GET_HIGHWAYS",
  obj,
});

export const getHighwaysSuccess = (data) => ({
  type: "GET_HIGHWAYS_SUCCESS",
  data,
});

export const getHighwaysFail = (error) => ({
  type: "GET_HIGHWAYS_FAIL",
  error,
});

export const getMouzas = (obj) => ({
  type: "GET_MOUZAS",
  obj,
});

export const getMouzasSuccess = (data) => ({
  type: "GET_MOUZAS_SUCCESS",
  data,
});

export const getMouzasFail = (error) => ({
  type: "GET_MOUZAS_FAIL",
  error,
});
export const getCircles = (obj) => ({
  type: "GET_CIRCLES",
  obj,
});

export const getCirclesSuccess = (data) => ({
  type: "GET_CIRCLES_SUCCESS",
  data,
});

export const getCirclesFail = (error) => ({
  type: "GET_CIRCLES_FAIL",
  error,
});

export const getDistricts = (obj) => ({
  type: "GET_DISTRICTS",
  obj,
});

export const getDistrictsSuccess = (data) => ({
  type: "GET_DISTRICTS_SUCCESS",
  data,
});

export const getDistrictsFail = (error) => ({
  type: "GET_DISTRICTS_FAIL",
  error,
});

export const getLocalities = (obj) => ({
  type: "GET_LOCALITIES",
  obj,
});

export const getLocalitiesSuccess = (data) => ({
  type: "GET_LOCALITIES_SUCCESS",
  data,
});

export const getLocalitiesFail = (error) => ({
  type: "GET_LOCALITIES_FAIL",
  error,
});

export const getLocalityCodes = (obj) => ({
  type: "GET_LOCALITY_CODES",
  obj,
});

export const getLocalityCodesSuccess = (data) => ({
  type: "GET_LOCALITY_CODES_SUCCESS",
  data,
});

export const getLocalityCodesFail = (error) => ({
  type: "GET_LOCALITY_CODES_FAIL",
  error,
});

export const getWards = (obj) => ({
  type: "GET_WARDS",
  obj,
});

export const getWardsSuccess = (data) => ({
  type: "GET_WARDS_SUCCESS",
  data,
});

export const getWardsFail = (error) => ({
  type: "GET_WARDS_FAIL",
  error,
});

export const getBlocks = (obj) => ({
  type: "GET_BLOCKS",
  obj,
});

export const getBlocksSuccess = (data) => ({
  type: "GET_BLOCKS_SUCCESS",
  data,
});

export const getBlocksFail = (error) => ({
  type: "GET_BLOCKS_FAIL",
  error,
});

export const getBuildingTypes = () => ({
  type: "GET_BUILDING_TYPES",
});

export const getBuildingTypesSuccess = (data) => ({
  type: "GET_BUILDING_TYPES_SUCCESS",
  data,
});

export const getBuildingTypesFail = (error) => ({
  type: "GET_BUILDING_TYPES_FAIL",
  error,
});

export const getPropertyTypes = () => ({
  type: "GET_PROPERTY_TYPES",
});

export const getPropertyTypesSuccess = (data) => ({
  type: "GET_PROPERTY_TYPES_SUCCESS",
  data,
});

export const getPropertyTypesFail = (error) => ({
  type: "GET_PROPERTY_TYPES_FAIL",
  error,
});
export const getPropertyClassifications = (obj) => ({
  type: "GET_PROPERTY_CLASSIFICATIONS",
  obj,
});

export const getPropertyClassificationsSuccess = (data) => ({
  type: "GET_PROPERTY_CLASSIFICATIONS_SUCCESS",
  data,
});

export const getPropertyClassificationsFail = (error) => ({
  type: "GET_PROPERTY_CLASSIFICATIONS_FAIL",
  error,
});
export const getInspectors = (obj) => ({
  type: "GET_INSPECTORS",
  obj,
});

export const getInspectorsSuccess = (data) => ({
  type: "GET_INSPECTORS_SUCCESS",
  data,
});

export const getInspectorsFail = (error) => ({
  type: "GET_INSPECTORS_FAIL",
  error,
});
export const getEtoCircles = (obj) => ({
  type: "GET_ETO_CIRCLES",
  obj,
});

export const getEtoCirclesSuccess = (data) => ({
  type: "GET_ETO_CIRCLES_SUCCESS",
  data,
});

export const getEtoCirclesFail = (error) => ({
  type: "GET_ETO_CIRCLES_FAIL",
  error,
});
export const getZones = (obj) => ({
  type: "GET_ZONES",
  obj,
});

export const getZonesSuccess = (data) => ({
  type: "GET_ZONES_SUCCESS",
  data,
});

export const getZonesFail = (error) => ({
  type: "GET_ZONES_FAIL",
  error,
});
export const getUserByZoneOrCircle = (obj) => ({
  type: "GET_USER_BY_ZONE_OR_CIRCLE",
  obj,
});

export const getUserByZoneOrCircleSuccess = (data) => ({
  type: "GET_USER_BY_ZONE_OR_CIRCLE_SUCCESS",
  data,
});

export const getUserByZoneOrCircleFail = (error) => ({
  type: "GET_USER_BY_ZONE_OR_CIRCLE_FAIL",
  error,
});
export const getUsers = (obj) => ({
  type: "GET_USERS",
  obj,
});

export const getUsersSuccess = (data) => ({
  type: "GET_USERS_SUCCESS",
  data,
});

export const getUsersFail = (error) => ({
  type: "GET_USERS_FAIL",
  error,
});
export const getEtoZones = (obj) => ({
  type: "GET_ETO_ZONES",
  obj,
});

export const getEtoZonesSuccess = (data) => ({
  type: "GET_ETO_ZONES_SUCCESS",
  data,
});

export const getEtoZonesFail = (error) => ({
  type: "GET_ETO_ZONES_FAIL",
  error,
});
export const getCirclesByZone = (obj) => ({
  type: "GET_CIRCLES_BY_ZONE",
  obj,
});

export const getCirclesByZoneSuccess = (data) => ({
  type: "GET_CIRCLES_BY_ZONE_SUCCESS",
  data,
});

export const getCirclesByZoneFail = (error) => ({
  type: "GET_CIRCLES_BY_ZONE_FAIL",
  error,
});

export const getTisByCircle = (obj) => ({
  type: "GET_TIS_BY_CIRCLE",
  obj,
});

export const getTisByCircleSuccess = (data) => ({
  type: "GET_TIS_BY_CIRCLE_SUCCESS",
  data,
});

export const getTisByCircleZoneFail = (error) => ({
  type: "GET_TIS_BY_CIRCLE_FAIL",
  error,
});

export const getBanks = (obj) => ({
  type: "GET_BANKS",
  obj,
});

export const getBanksSuccess = (data) => ({
  type: "GET_BANKS_SUCCESS",
  data,
});

export const getBanksFail = (error) => ({
  type: "GET_BANKS_FAIL",
  error,
});

export const getBranches = (obj) => ({
  type: "GET_BRANCHES",
  obj,
});

export const getBranchesSuccess = (data) => ({
  type: "GET_BRANCHES_SUCCESS",
  data,
});

export const getBranchesFail = (error) => ({
  type: "GET_BRANCHES_FAIL",
  error,
});
export const getCircleOrZoneOfDistrict = (obj) => ({
  type: "GET_CIRCLE_OR_ZONE_OF_DISTRICT",
  obj,
});

export const getCircleOrZoneOfDistrictSuccess = (data) => ({
  type: "GET_CIRCLE_OR_ZONE_OF_DISTRICT_SUCCESS",
  data,
});

export const getCircleOrZoneOfDistrictFail = (error) => ({
  type: "GET_CIRCLE_OR_ZONE_OF_DISTRICT_FAIL",
  error,
});
